import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './table-popup-checklist.component.scss';
import { MediaQueryService } from '../../services/media-query.service';
import * as $ from 'jquery';
var TablePopupChecklist = /** @class */ (function (_super) {
    tslib_1.__extends(TablePopupChecklist, _super);
    function TablePopupChecklist(element) {
        var _this = _super.call(this, element) || this;
        _this.event.register('openModal', _this, _this.openModal.bind(_this));
        return _this;
    }
    TablePopupChecklist.prototype.init = function () {
        var _this = this;
        this.modals = Array.from(this.element.querySelectorAll('.js-table-popup-checklist-modal'));
        this.modalLinks = Array.from(document.querySelectorAll('.js-table-popup-checklist-modal-open'));
        this.closeButton = this.element.querySelector('.js-table-popup-checklist-modal-close');
        this.tableHeader = this.element.querySelector('.js-table-header');
        this.tableRows = Array.from(this.element.querySelectorAll('.js-table-row'));
        setTimeout(function () {
            _this.equalHeights();
        }, 100);
    };
    TablePopupChecklist.prototype.bindEvents = function () {
        var _this = this;
        this.modals.map(function (item) { return item.addEventListener('click', function (event) {
            _this.isClickOutsideModal(event);
        }); });
        this.closeButton.addEventListener('click', function (event) { return _this.closeModal(); });
        this.modalLinks.map(function (item) { return item.addEventListener('click', function (event) {
            _this.openModals(event);
        }); });
        window.addEventListener('resize', this.onResize.bind(this));
        window.addEventListener('orientationchange', this.onResize.bind(this));
    };
    TablePopupChecklist.prototype.onResize = function () {
        var _this = this;
        setTimeout(function () {
            _this.equalHeights();
        }, 100);
    };
    TablePopupChecklist.prototype.equalHeights = function () {
        this.defaultHeights();
        if (MediaQueryService.getMediaQuery() === 'small' || MediaQueryService.getMediaQuery() === 'x-small') {
            var tallestHeader = this.getTallestColumnInRow(this.tableHeader, 'th');
            this.tableHeader.style.height = tallestHeader + "px";
            for (var i = 0; i < this.tableRows.length; i++) {
                var tallestColumn = this.getTallestColumnInRow(this.tableRows[i], 'td');
                this.tableRows[i].style.height = tallestColumn + "px";
            }
        }
    };
    TablePopupChecklist.prototype.getTallestColumnInRow = function (row, type) {
        var columns = row.querySelectorAll(type);
        var tallestColumn = 60;
        for (var i = 0; i < columns.length; i++) {
            var el = columns[i];
            var elHeight = el.offsetHeight;
            if (elHeight > tallestColumn) {
                tallestColumn = elHeight;
            }
        }
        return tallestColumn;
    };
    TablePopupChecklist.prototype.defaultHeights = function () {
        this.tableHeader.style.height = '';
        for (var i = 0; i < this.tableRows.length; i++) {
            this.tableRows[i].style.height = '';
        }
    };
    TablePopupChecklist.prototype.isClickOutsideModal = function (event) {
        if (event.target === this.activeModal) {
            this.closeModal();
        }
    };
    TablePopupChecklist.prototype.openModals = function (event) {
        var element = event.target;
        var modalId = element.getAttribute('data-modal');
        if (!modalId) {
            var parentElement = $(element).closest('.js-table-popup-checklist-modal-open');
            modalId = parentElement.attr('data-modal');
        }
        this.activeModal = this.getModalById(modalId);
        this.openModal();
    };
    TablePopupChecklist.prototype.closeModal = function () {
        var _this = this;
        this.activeModal.classList.add('modal--close');
        setTimeout(function () {
            _this.activeModal.classList.add('modal--closed');
        }, 250);
    };
    TablePopupChecklist.prototype.openModal = function () {
        this.activeModal.classList.remove('modal--close');
        this.activeModal.classList.remove('modal--closed');
        this.equalHeights();
    };
    TablePopupChecklist.prototype.getModalById = function (id) {
        return document.querySelector("#" + id);
    };
    return TablePopupChecklist;
}(Base));
export { TablePopupChecklist };



//////////////////
// WEBPACK FOOTER
// ./components/table-popup-checklist/table-popup-checklist.component.ts
// module id = 533
// module chunks = 0